// extracted by mini-css-extract-plugin
module.exports = {"tableInputWrapper":"TableInput_tableInputWrapper__CSbBO","tableInputPencil":"TableInput_tableInputPencil__LACtS","tableInput":"TableInput_tableInput__3J-Yw"};